const CHATS_DOMAIN = 'chats'

const CHATS_KEY = {
  ALL: 'all',
  DATA: 'data',
  CURRENT: 'current'
}

const CHATS_PATH = {
  ALL: `${CHATS_DOMAIN}.${CHATS_KEY.ALL}`,
  ALL_DATA: `${CHATS_DOMAIN}.${CHATS_KEY.ALL}.data`,
  DATA: `${CHATS_DOMAIN}.${CHATS_KEY.DATA}`,
  CURRENT: `${CHATS_DOMAIN}.${CHATS_KEY.CURRENT}`
}

const CHATS_STATE = {
  [CHATS_KEY.ALL]: {
    data: [],
    status: null
  },
  [CHATS_KEY.CURRENT]: null,
  [CHATS_KEY.DATA]: {}
}

const CHATS_ANALYTICS_EVENT = {
  CREATED: 'Chat Created',
  CLOSED: 'Chat Closed',
  LINK_PRESSED: 'Chat Link Pressed',
  REPLY_ADDED: 'Chat Reply Added',
  DELETED: 'Chat Deleted'
}

const CHATS_ACTION = {
  CREATE: 'CHATS_CREATE',
  CLOSE: 'CHATS_CLOSE',
  ADD_REPLY: 'CHATS_ADD_REPLY',
  LOAD: 'CHATS_LOAD',
  LOAD_BY_ID: 'CHATS_LOAD_BY_ID',
  SAVE: 'CHATS_SAVE',
  UPDATE_CURRENT: 'CHATS_UPDATE_CURRENT',
  UPDATE_MESSAGE: 'CHATS_UPDATE_MESSAGE',
  UPDATE_READ_AT: 'CHATS_UPDATE_READ_AT',
  DELETE_CURRENT: 'CHATS_DELETE_CURRENT',
  UPDATE: 'CHATS_UPDATE',
  DELETE: 'CHATS_DELETE'
}

const ROOT = '/chats'
const CHATS_ENDPOINT = {
  ROOT,
  MESSAGES: '/chats/:id/messages'
}

export {
  CHATS_DOMAIN,
  CHATS_KEY,
  CHATS_PATH,
  CHATS_STATE,
  CHATS_ANALYTICS_EVENT,
  CHATS_ACTION,
  CHATS_ENDPOINT
}
